<template>
  <div @click="clickLink">
    <li>
      <a class="menu-item" :class="{ active: isActive }">
        <div class="icon">
          <svg
            v-if="isHomeMenuType"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="2"
              y="1"
              width="21"
              height="22"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 1.00024H22.4998V22.5052H2V1.00024Z"
                fill="black"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.7168 15.2914C14.9208 15.2914 15.9008 16.2644 15.9008 17.4604V20.5364C15.9008 20.7934 16.1068 20.9994 16.3708 21.0054H18.2768C19.7788 21.0054 20.9998 19.7994 20.9998 18.3174V9.59337C20.9928 9.08337 20.7498 8.60337 20.3328 8.28437L13.7398 3.02637C12.8548 2.32537 11.6168 2.32537 10.7288 3.02837L4.18076 8.28237C3.74776 8.61137 3.50476 9.09137 3.49976 9.61037V18.3174C3.49976 19.7994 4.72076 21.0054 6.22276 21.0054H8.14676C8.41776 21.0054 8.63776 20.7904 8.63776 20.5264C8.63776 20.4684 8.64476 20.4104 8.65676 20.3554V17.4604C8.65676 16.2714 9.63076 15.2994 10.8258 15.2914H13.7168ZM18.2768 22.5054H16.3528C15.2508 22.4794 14.4008 21.6144 14.4008 20.5364V17.4604C14.4008 17.0914 14.0938 16.7914 13.7168 16.7914H10.8308C10.4618 16.7934 10.1568 17.0944 10.1568 17.4604V20.5264C10.1568 20.6014 10.1468 20.6734 10.1258 20.7414C10.0178 21.7314 9.17176 22.5054 8.14676 22.5054H6.22276C3.89376 22.5054 1.99976 20.6264 1.99976 18.3174V9.60337C2.00976 8.60937 2.46776 7.69937 3.25876 7.10037L9.79376 1.85537C11.2328 0.715372 13.2378 0.715372 14.6738 1.85337L21.2558 7.10337C22.0288 7.69237 22.4868 8.60037 22.4998 9.58237V18.3174C22.4998 20.6264 20.6058 22.5054 18.2768 22.5054Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            v-else-if="isSearchMenuType"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="2"
              y="2"
              width="20"
              height="20"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 2H21.4768V21.477H2V2Z"
                fill="black"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.7388 3.5C7.19576 3.5 3.49976 7.195 3.49976 11.738C3.49976 16.281 7.19576 19.977 11.7388 19.977C16.2808 19.977 19.9768 16.281 19.9768 11.738C19.9768 7.195 16.2808 3.5 11.7388 3.5ZM11.7388 21.477C6.36876 21.477 1.99976 17.108 1.99976 11.738C1.99976 6.368 6.36876 2 11.7388 2C17.1088 2 21.4768 6.368 21.4768 11.738C21.4768 17.108 17.1088 21.477 11.7388 21.477Z"
                fill="white"
              />
            </g>
            <mask
              id="mask1"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="17"
              y="17"
              width="6"
              height="6"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.24 17.7069H22.264V22.7217H17.24V17.7069Z"
                fill="black"
              />
            </mask>
            <g mask="url(#mask1)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5142 22.7217C21.3232 22.7217 21.1312 22.6487 20.9842 22.5027L17.4602 18.9887C17.1672 18.6957 17.1662 18.2207 17.4592 17.9277C17.7512 17.6327 18.2262 17.6347 18.5202 17.9257L22.0442 21.4407C22.3372 21.7337 22.3382 22.2077 22.0452 22.5007C21.8992 22.6487 21.7062 22.7217 21.5142 22.7217Z"
                fill="white"
              />
            </g>
          </svg>
          <svg
            v-else-if="isLikesMenuType"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="2"
              y="2"
              width="21"
              height="21"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 2.99988H22.4725V22.5009H2V2.99988Z"
                fill="black"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.82371 12.123C5.22571 16.485 10.7647 20.012 12.2367 20.885C13.7137 20.003 19.2927 16.437 20.6497 12.127C21.5407 9.341 20.7137 5.812 17.4277 4.753C15.8357 4.242 13.9787 4.553 12.6967 5.545C12.4287 5.751 12.0567 5.755 11.7867 5.551C10.4287 4.53 8.65471 4.231 7.03771 4.753C3.75671 5.811 2.93271 9.34 3.82371 12.123ZM12.2377 22.501C12.1137 22.501 11.9907 22.471 11.8787 22.41C11.5657 22.239 4.19271 18.175 2.39571 12.581C2.39471 12.581 2.39471 12.58 2.39471 12.58C1.26671 9.058 2.52271 4.632 6.57771 3.325C8.48171 2.709 10.5567 2.98 12.2347 4.039C13.8607 3.011 16.0207 2.727 17.8867 3.325C21.9457 4.634 23.2057 9.059 22.0787 12.58C20.3397 18.11 12.9127 22.235 12.5977 22.408C12.4857 22.47 12.3617 22.501 12.2377 22.501Z"
                fill="white"
              />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.1537 10.6249C17.7667 10.6249 17.4387 10.3279 17.4067 9.9359C17.3407 9.1139 16.7907 8.4199 16.0077 8.1669C15.6127 8.0389 15.3967 7.6159 15.5237 7.2229C15.6527 6.8289 16.0717 6.6149 16.4677 6.7389C17.8307 7.1799 18.7857 8.3869 18.9027 9.8139C18.9357 10.2269 18.6287 10.5889 18.2157 10.6219C18.1947 10.6239 18.1747 10.6249 18.1537 10.6249Z"
              fill="white"
            />
          </svg>
        </div>
        <span class="text">{{ label }} </span>
      </a>
    </li>
  </div>
</template>

<script>
export default {
  name: "SidebarMenuItem",
  props: {
    type: {
      type: String,
      default: "Home",
    },
    label: {
      type: String,
    },
    link: {
      type: String,
      default: "/",
    },
    name: {
      type: String,
    },
  },
  data() {
    return {
      route: "",
    };
  },
  created() {
    if (this.route === "") {
      this.route = this.$router.currentRoute.name;
    }
  },
  watch: {
    $route: function (newRoute, oldRoute) {
      this.route = newRoute.name;
    },
  },
  computed: {
    isHomeMenuType() {
      return this.type === "home";
    },
    isSearchMenuType() {
      return this.type === "search";
    },
    isLikesMenuType() {
      return this.type === "likes";
    },
    isActive() {
      return this.route === this.name;
    },
  },
  methods: {
    clickLink() {
      //   if (this.link === "/random") {
      // this.feelingLucky();
      //   } else {
      this.goToLink(this.link);
      //   }
    },
    goToLink(link) {
      this.$router.push(link);
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  padding: 0 8px;
  .menu-item {
    border-radius: 4px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    height: 40px;
    color: white;
    // color: #b3b3b3;
    transition-timing-function: linear;
    transition-property: color;
    text-decoration: none;
    &:hover {
      color: white;
      text-decoration: none;
    }
    &.active {
      // background-color: #3a3a3a;
      background-color: #2d3048;
      color: white;
      border-radius: 4px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      height: 40px;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      height: 36px;
      max-height: 36px;
      width: 36px;
      max-width: 36px;
    }
    .text {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: normal;
      text-transform: none;
    }
  }
}
</style>
